import { skipToken, useQuery } from '@tanstack/react-query';

import { useCompany } from '~hooks/useCompany/useCompany';

interface UseCompanyDefaultPaymentTermIdQueryProps {
  companyId?: string;
}

export default function useCompanyDefaultPaymentTermIdQuery({
  companyId,
}: UseCompanyDefaultPaymentTermIdQueryProps) {
  const { getCompanyById } = useCompany();

  const { data, isFetching } = useQuery({
    queryKey: ['companyDefaultPaymentTermId', companyId],
    queryFn: companyId
      ? async ({ signal }) => {
          const company = await getCompanyById({ id: companyId, signal });

          return company?.defaultPaymentTermId ?? null;
        }
      : skipToken,
    // getCompanyById already toasts a failure, so a retry would toast it again.
    retry: false,
  });

  return {
    defaultPaymentTermId: data ?? null,
    isFetchingDefaultPaymentTermId: isFetching,
  };
}
